import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetEventRequest extends IBaseRequest {
    ident: string;
    userId: string;
}

export class GetEventRequest extends BaseRequest implements IGetEventRequest {
    public ident: string;
    public userId: string;

  constructor(server: string, session: string, ident:string, userId:string) {
    super(server, session);
    this.ident = ident;
    this.userId = userId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.ident, 'ident');
    parameters += this.makeNode(this.userId, 'userId');
    return super.wrapperXml('GetEvent', parameters);
  }
}
